var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseForm',{attrs:{"on-success":_vm.save}},[_vm._t("default",null,{"cancel":_vm.cancel,"itemIsNew":_vm.itemIsNew})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }